import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from '../pages/app'

// entry-client runs ONLY in the browser (hydration), so the global `window` is
// guaranteed here. No @ztechapps/common.utils `getWindow` — that barrel is not
// tree-shakeable and bloats the client bundle (~2 MB). The SSR route context is
// serialized into the page by entry-server.tsx.
type RouteContextWindow = Window & { __ROUTE_CONTEXT__?: Record<string, unknown> }
const routeContext = (window as unknown as RouteContextWindow).__ROUTE_CONTEXT__

ReactDOM.hydrateRoot(
  document.getElementById('app') as HTMLElement,
  <BrowserRouter>
    <App routeContext={routeContext} />
  </BrowserRouter>
)
